import { staffClient } from 'clients/staff';
import { getS3UploadUrl, uploadS3File } from 'utils/s3';

export interface Patent {
    id: number;
    patent_number: string;
    application_number: string;
    application_date: string;
    registration_date: string;
    expiry_date: string;
    invention_title: string;
    patent_holder: string;
    inventors: string;
    certificate_url?: string;
    is_visible: boolean;
    created_at: string;
    updated_at: string;
}

export interface PatentListResponse {
    data: Patent[];
    total: number;
    offset: number;
    limit: number;
}

export interface CreatePatentDto {
    patent_number: string;
    application_number: string;
    application_date: string;
    registration_date: string;
    expiry_date: string;
    invention_title: string;
    patent_holder: string;
    inventors: string;
    certificate_url?: string;
}

export interface UpdatePatentDto {
    patent_number?: string;
    application_number?: string;
    application_date?: string;
    registration_date?: string;
    expiry_date?: string;
    invention_title?: string;
    patent_holder?: string;
    inventors?: string;
    certificate_url?: string;
    is_visible?: boolean;
}

export const patentApi = {
    // Get all patents with pagination and search
    getPatents: async (params?: {
        offset?: number;
        limit?: number;
        searchText?: string;
    }) => {
        return await staffClient.get<PatentListResponse>('/patent', { params });
    },

    // Get single patent by ID
    getPatent: async (id: number) => {
        return await staffClient.get<Patent>(`/patent/${id}`);
    },

    // Create new patent
    createPatent: async (data: CreatePatentDto) => {
        return await staffClient.post<Patent>('/patent', data);
    },

    // Update patent
    updatePatent: async (id: number, data: UpdatePatentDto) => {
        return await staffClient.patch<Patent>(`/patent/${id}`, data);
    },

    // Delete patent
    deletePatent: async (id: number) => {
        return await staffClient.delete(`/patent/${id}`);
    },

    // Upload certificate image using S3
    uploadCertificate: async (file: File) => {
        try {
            // Get S3 upload URL
            const uploadUrl = await getS3UploadUrl(file);
            if (!uploadUrl) {
                throw new Error('Failed to get upload URL');
            }
            
            // Upload file to S3
            const imageUrl = await uploadS3File(file, uploadUrl);
            if (!imageUrl) {
                throw new Error('Failed to upload file');
            }
            
            return imageUrl;
        } catch (error) {
            console.error('Failed to upload certificate:', error);
            throw error;
        }
    }
};